import {TagGroup, TagID} from "/@src/models/api";
import {FormData} from "/@src/models/form";
import {TagData} from "/@src/models/content";

export default function useContentBase() {
  /**
   * 根据tag relation给content功能属性赋值
   * @param content
   */
  const updateContentForm = (content: FormData<any>)=>{
    if (content.tagRelations && content.tagRelations.length > 0) {
      content.tagRelations.map((relation) => {
        if (relation.id === TagID.MATRIX) {
          if (relation.group === TagGroup.FEATURED_FLOW) {
            content.isFeatured = true
          }
        } else {
          // 是典藏库时，更新tag的属性值
          if (relation.group === TagGroup.TREASURY) {
            const tag = content.tags?.find(value => value.id === relation.id)
            if (tag) {
              (tag as TagData).treasury = true
            }
          }
        }
      })
    }
  }
  return {
    updateContentForm,
  }
}
